class Color {
    constructor(red, green, blue) {
        if (red || green || blue) {
            this.isDefault = false;
            this.red = red !== null && red !== void 0 ? red : 0;
            this.green = green !== null && green !== void 0 ? green : 0;
            this.blue = blue !== null && blue !== void 0 ? blue : 0;
        }
        else {
            this.isDefault = true;
        }
    }
    toString() {
        if (this.isDefault) {
            return "currentColor";
        }
        else {
            return "#" +
                Math.floor(this.red).toString(16) +
                Math.floor(this.green).toString(16) +
                Math.floor(this.blue).toString(16);
        }
    }
}
export default Color;
